(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Allergen', Allergen);

    Allergen.$inject = ['$resource'];

    function Allergen ($resource) {
        var resourceUrl =  'api/allergens/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/allergens/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
